import apiClient, { jsonRequestConfig } from "./httpClient";
import endpoints from "./endpoints";

export const devicesApi = {
  filtered: (organizationId) => apiClient.get(endpoints.device.filtered(organizationId)),
  filteredSseUrl: (organizationId) => endpoints.device.filteredSse(organizationId),
  getSseUrl: (deviceId) => endpoints.device.getSse(deviceId),
  planAction: (deviceId, payload) =>
    apiClient.post(endpoints.device.planAction(deviceId), payload, jsonRequestConfig),
  planRequest: (deviceId, payload) =>
    apiClient.post(endpoints.device.planRequest(deviceId), payload, jsonRequestConfig),
  delete: (deviceId) => apiClient.delete(endpoints.device.delete(deviceId)),
  deleteMany: (ids) => apiClient.post(endpoints.device.deleteMany(), ids, jsonRequestConfig),
  deleteData: (body) => apiClient.post(endpoints.data.delete(), body, jsonRequestConfig),
};

export default devicesApi;
